import React from 'react';

export const PilotageStoreContext = React.createContext(null);
